import PropertiesList from './PropertiesList';

export default PropertiesList;
